import { AppConfig } from '@dh-io-emh/config-types';
import { IPointOfServiceStock } from '../models/point-of-service.model';
import { createHttpService } from '../utils/http.util';

export type PosApi = ReturnType<typeof createPOSApi>;

export const createPOSApi = ({ config: { apiBaseUrl, lang, siteId } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: `${apiBaseUrl}/v2/${siteId}`,
    params: { lang },
  });

  return {
    getPointOfService: (outletId: string): Promise<IPointOfServiceStock> =>
      http
        .get<IPointOfServiceStock>(`pointofservices/${outletId}?fields=FULL`)
        .then((res) => res.data)
        .then((data) => {
          data.address.cityZipcodeLine = `${data?.address?.postalCode} ${data?.address?.town}`;

          return data;
        }),
  };
};
